import _styled from '@emotion/styled/base';
import { IconTimelineIndicator, IconStaticStatusAlert, IconStaticStatusSuccess } from '@hubble/icons/web';
import { Flex } from '../Flex/index.js';
import { List as List$1 } from '../List/styles.js';
import { Text } from '../Text/index.js';
import { Spacing } from '../primitives/spacing.js';

const Metadata = _styled(Text.Body, {
  target: "e1xzt56t12"
})("color:", ({
  theme
}) => theme.colorScheme.content.secondary, ";margin-top:", Spacing.scale[0.5], ";");
const StepBody = _styled("div", {
  target: "e1xzt56t11"
})("margin-left:", Spacing.scale[2.5], ";margin-bottom:", Spacing.scale[3], ";");
const List = _styled(List$1, {
  target: "e1xzt56t10"
})("li{list-style:none;}li:last-of-type{", StepBody, "{margin-bottom:0;}}");
const Connector = _styled("div", {
  target: "e1xzt56t9"
})("flex:1;background-color:", ({
  theme
}) => theme.colorScheme.border.secondary, ";width:2px;margin-top:-6px;margin-bottom:-6px;");
const ConnectorProgress = _styled("div", {
  target: "e1xzt56t8"
})("background-color:", ({
  theme
}) => theme.colorScheme.content.primary, ";width:2px;height:", props => props.stepComplete ? '100%' : '0', ";transition:height 0.3s;transition-delay:0.2s;");
const NotStarted = _styled(IconTimelineIndicator, {
  target: "e1xzt56t7"
})("fill:", ({
  theme
}) => theme.colorScheme.border.secondary, ";");
const InProgress = _styled(IconTimelineIndicator, {
  target: "e1xzt56t6"
})("fill:", ({
  theme
}) => theme.colorScheme.content.primary, ";z-index:1;");
const StepStatus = _styled(Flex, {
  target: "e1xzt56t5"
})("width:", Spacing.scale[3], ";");
const StatusSuccess = _styled(IconStaticStatusAlert, {
  target: "e1xzt56t4"
})("z-index:1;&>path:first-of-type{fill:", ({
  theme
}) => theme.colorScheme.content.primary, ";}&>path:nth-of-type(2){fill:", ({
  theme
}) => theme.colorScheme.background.primary, ";}");
const StatusAlert = _styled(IconStaticStatusSuccess, {
  target: "e1xzt56t3"
})("z-index:1;&>path:first-of-type{fill:", ({
  theme
}) => theme.colorScheme.content.primary, ";}&>path:nth-of-type(2){fill:", ({
  theme
}) => theme.colorScheme.background.primary, ";}");
_styled("ul", {
  target: "e1xzt56t2"
})("list-style-type:disc;margin:", Spacing.scale[1], " 0 ", Spacing.scale[1], " ", Spacing.scale[2], ";");
const FadeInScaleIcon = _styled("div", {
  target: "e1xzt56t1"
})("opacity:", props => props.animate ? 1 : 0, ";transition:all 0.4s;transform:", props => props.animate ? 'scale(1)' : 'scale(0)', ";");
const IconTransition = _styled("div", {
  target: "e1xzt56t0"
})("display:flex;width:", Spacing.scale[3], ";height:", Spacing.scale[3], ";", NotStarted, "{position:absolute;}");

export { Connector, ConnectorProgress, FadeInScaleIcon, IconTransition, InProgress, List, Metadata, NotStarted, StatusAlert, StatusSuccess, StepBody, StepStatus };
